<lib-app-wrapper>
  <router-outlet></router-outlet>
</lib-app-wrapper>